import { useQueries } from "@tanstack/react-query";
import { getSingleAttachments } from "../api/incident/apiIncidents";

interface AttachmentMetadata {
  uploadedBy: string;
  uploadedAt: string;
  name: string;
  isUploadedFromWebApp: boolean;
  fileExtension: string;
  attachmentId: string;
}

interface AttachmentWithData extends AttachmentMetadata {
  base64Data?: string;
}

export const useMultipleAttachments = (attachments: AttachmentMetadata[]) => {
  const attachmentQueries = useQueries({
    queries: attachments.map((attachment) => ({
      queryKey: ["attachment", attachment.attachmentId],
      queryFn: () => getSingleAttachments(attachment.attachmentId),
      enabled: !!attachment.attachmentId,
    })),
  });

  const isLoading = attachmentQueries.some((query) => query.isLoading);
  const isError = attachmentQueries.some((query) => query.isError);
  const errors = attachmentQueries
    .map((query) => query.error)
    .filter((error): error is Error => !!error);

  // Merge the base64 data with the original attachment metadata
  const data: AttachmentWithData[] = attachments.map((attachment, index) => ({
    ...attachment,
    base64Data: attachmentQueries[index].data?.data?.data || "",
  }));

  return {
    data,
    isLoading,
    isError,
    errors,
  };
};
